import { render, staticRenderFns } from "./PolicyCoverage.vue?vue&type=template&id=631ee770&"
import script from "./PolicyCoverage.vue?vue&type=script&lang=js&"
export * from "./PolicyCoverage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports